import { jsx } from '@emotion/core';
import { hasOwnProp } from '../../../../utils';
import { IconContainer } from '../../../Common';
import { AmexCardArt, CBNationaleCardArt, CetelemCardArt, CofinogaCardArt, DefaultCardArt, DefaultCardArtV2, DinersCardArt, DiscoverCardArt, EloCardArt, HiperCardArt, HipercardCardArt, JcbCardArt, MaestroCardArt, MastercardCardArt, RuPayCardArt, UnionPayCardArt, VisaCardArt } from './Icons';
export var CARD_ART_MAP = {
  AMEX: AmexCardArt,
  CB_NATIONALE: CBNationaleCardArt,
  CETELEM: CetelemCardArt,
  CHINA_UNION_PAY: UnionPayCardArt,
  COFINOGA: CofinogaCardArt,
  DEFAULT: DefaultCardArt,
  DEFAULT_V2: DefaultCardArtV2,
  DINERS: DinersCardArt,
  DISCOVER: DiscoverCardArt,
  ELO: EloCardArt,
  HIPER: HiperCardArt,
  HIPERCARD: HipercardCardArt,
  JCB: JcbCardArt,
  MAESTRO: MaestroCardArt,
  MASTER_CARD: MastercardCardArt,
  RUPAY: RuPayCardArt,
  VISA: VisaCardArt,
  CBNATIONALE: CBNationaleCardArt,
  MASTERCARD: MastercardCardArt,
  SWITCH: MaestroCardArt,
  CUP: UnionPayCardArt
};
export var CardArt = _ref => {
  var {
    cardType,
    isLeft,
    styleOverrides,
    isV2
  } = _ref;
  var isDefaultV2 = isV2 && cardType === 'DEFAULT';

  if (isDefaultV2) {
    cardType = 'DEFAULT_V2';
  }

  var CardArtComponent = hasOwnProp(CARD_ART_MAP, cardType) ? CARD_ART_MAP[cardType] : CARD_ART_MAP.DEFAULT;
  return jsx(IconContainer, {
    css: styleOverrides,
    height: isDefaultV2 ? '38px' : '25px',
    isLeft: isLeft,
    width: "38px"
  }, jsx(CardArtComponent, null));
};